import React from 'react';
import { useTranslation } from 'react-i18next';

const ParcelStatusHistory = ({statusHistory}) => {
  const { t } = useTranslation('tracking');
  if (!statusHistory || !statusHistory.length) {
    return null;
  }

  return (
    <div className='status-history'>
      <div className='animated fadeIn'>
        <h3 className='section-title text-center'>
          {t('deliveryStatusTitle')}
        </h3>
        <ul className='box'>
          { statusHistory.map(({ date, statusText, iconUrl }, i) => {
            return (
              <li key={i}>
                {date ? <span className='timestamp'>{date}</span> : null}
                <span className='status'>
                  {iconUrl && <img src={iconUrl} className={`status-icon ${lang}`} alt='Status icon' />}
                  {statusText}
                </span>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

export {
  ParcelStatusHistory
};
